import {
  StyleSheet,
} from 'react-native';

import {
  primaryColor,
  primaryColorWithOpacity,
  primaryFont700,
} from './Common';

export default StyleSheet.create({
  secondaryContainer: {
    // width: imageWidth,
  },
  secondaryTitle: {
    color: primaryColor,
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  secondary: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColorWithOpacity,
    borderColor: primaryColor,
    borderRadius: 8,
    margin: 10,
  },
  secondaryTitleDisabled: {
    color: 'black',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  secondaryDisabled: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColorWithOpacity,
    borderColor: primaryColor,
    borderRadius: 8,
    margin: 10,
    opacity: 0.3,
  },
  primaryContainer: {
    // width: imageWidth,
  },
  primaryTitle: {
    color: 'white',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  primary: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 8,
    margin: 10,
  },
  primaryTitleDisabled: {
    color: 'black',
    fontFamily: primaryFont700,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 20,
    padding: 0,
    margin: 0,
  },
  primaryDisabled: {
    paddingHorizontal: 30,
    paddingVertical: 10,
    backgroundColor: primaryColor,
    borderColor: primaryColor,
    borderRadius: 8,
    margin: 10,
    opacity: 0.3,
  },
});
